import { render, staticRenderFns } from "./404-not-found.vue?vue&type=template&id=4bc6266a&scoped=true"
import script from "./404-not-found.vue?vue&type=script&lang=js"
export * from "./404-not-found.vue?vue&type=script&lang=js"
import style0 from "./404-not-found.vue?vue&type=style&index=0&id=4bc6266a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6266a",
  null
  
)

export default component.exports